import { LineKeyType_Enum } from '@weave/schema-gen-ts/dist/schemas/phone/devices/v2/devices.pb';
import { t } from 'i18next';
import { theme } from '@frontend/theme';

export const DEVICE_LAYOUT_WIDTH = '720px';
export const LINE_KEY_FONT_SIZE = theme.fontSize(20);
export const LAYOUT_HEIGHT_HEADER_FOOTER = theme.spacing(11);
export const LAYOUT_TOUCH_SCREEN_HEIGHT_HEADER_FOOTER = theme.spacing(6);

export const LineKeyCardTitle: Record<LineKeyType_Enum, string> = {
  UNSPECIFIED: t('Unspecified', { ns: 'phone' }),
  DATA_ENDPOINT: t('Data Endpoint', { ns: 'phone' }),
  LOCAL_CONTACT: t('Contact', { ns: 'phone' }),
  OFFICE_EXTENSION: t('Office Extension', { ns: 'phone' }),
  PARK_SLOT: t('Hold', { ns: 'phone' }),
  PERSONAL_VOICEMAIL: t('Personal Voicemail', { ns: 'phone' }),
  USER_EXTENSION: t('Device Extension', { ns: 'phone' }),
  VOICEMAIL_EXTENSION: t('Voicemail', { ns: 'phone' }),
};

export const LineKeyCardDropdownLabel: Record<LineKeyType_Enum, string> = {
  UNSPECIFIED: t('Unspecified', { ns: 'phone' }),
  DATA_ENDPOINT: t('Data Endpoint', { ns: 'phone' }),
  LOCAL_CONTACT: t('Contact', { ns: 'phone' }),
  OFFICE_EXTENSION: t('Extension Name', { ns: 'phone' }),
  PARK_SLOT: t('Hold Slot', { ns: 'phone' }),
  PERSONAL_VOICEMAIL: t('Voicemail Box', { ns: 'phone' }),
  USER_EXTENSION: t('Device Name', { ns: 'phone' }),
  VOICEMAIL_EXTENSION: t('Voicemail Box', { ns: 'phone' }),
};
